import { render, staticRenderFns } from "./SettingsCustomFields.vue?vue&type=template&id=29f565d0"
import script from "./SettingsCustomFields.vue?vue&type=script&lang=js"
export * from "./SettingsCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports